var moo = require('@webhare-system/frameworks/mootools/core');
var domfocus = require('@webhare-system/dom/focus');

/* IE FOCUS FIX - IE allows <divs> and some other elements to receive focus, if directly clicked.
   Debugged it using:

  ( function() { if(document.activeElement) ($$('.wh-menubar')[0] || $$('#demo h1')[0]).set('text', (document.activeElement.outerHTML || document.activeElement.innerHTML).substr(0,100));}).periodical(100);

*/
if(moo.Browser.name=="ie")
{
  window.addEventListener("focus", function(event)
  {
    for(var settarget = event.target; settarget && !domfocus.isFocusableComponent(settarget); settarget=settarget.parentNode)
      ; //iterate until we find a target

    if(settarget && settarget != event.target && !settarget.isContentEditable)
      settarget.focus();
  },true);
}



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/modules/system/nodejs/compat/iefocusfix.js
// module id = 1114
// module chunks = 0